import { get, post } from './index'
import axios from 'axios'
import config from '@/config'
import moment from 'moment'
export function transformPost(url, params, other = {}) {
  return axios(
    {
      url,
      baseURL: config.domainName,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        loginToken: sessionStorage.getItem('loginToken'),
      }, // 头部信息处理
      transformResponse: [
        function (response) {
          return JSON.parse(response.replace(/("id":)(\d{0,})(,)/g, '$1' + '"' + '$2' + '"' + '$3'))
        },
      ],
    },
    {
      prefix: config.mobServer,
      ...other,
    }
  )
}
// 查询是否好时光产品
export function planGoodTimeProductIs(params) {
  return get('/discounts/plan-good-time/product-is', params)
}

// 查询用户是否好时光会员
export function planGoodTimeExits(params) {
  return get('/discounts/plan-good-time/exits', params)
}

// 将用户加入好时光会员
export function planGoodTimeJoin(params) {
  return post('/discounts/plan-good-time/join', params)
}

// 根据标签名称查询文章信息
export function getArticleDetailByTag(params) {
  return transformPost('/openapi/content/getArticleDetailByTag', params)
}
// 获取产品详情
export function getProductDetail(params) {
  return post('/product/detail', {
    terminalCode: sessionStorage.getItem('terminalCode'),
    activityChannelNoStr: sessionStorage.getItem('sourceFlag'),
    memberId: sessionStorage.getItem('memberId') || '',
    ...params,
  })
}
// 获取产品详情【无行程、签约合同、优惠活动信息】
export function getProductDetailV2(params) {
  return post('/product/detail', {

    showCoupon: sessionStorage.getItem('terminalCode') != '04',
    terminalCode: sessionStorage.getItem('terminalCode'),
    activityChannelNoStr: sessionStorage.getItem('sourceFlag'),
    version: 'v2',
    memberId: sessionStorage.getItem('memberId') || '',
    ...params,
  })
}
// 获取产品列表
export function getProductList(params) {
  const sourceFlag = sessionStorage.getItem('sourceFlag')
  return post('/product/list/v2', {
    ...params,
    activityChannelNoStr: sourceFlag,
    priceChannelNoStr: sourceFlag,
  })
}
export function getProductListV3(params) {
  return post('/product/list/v3', params)
}
// 获取城市列表
export function getAllCitys() {
  return post('/city/listMap')
}
// 获取国家列表
export function getAllCountrys(p = {}) {
  return post('/query-pinyin-country', p)
}
// 获取根据城市名称查询城市ID
export function getInquireCity(params) {
  return post('/citys', params)
}
// 获取日历价格-根据产品编码查询价格日历
// @param productId 产品编码
// @param resourceId 资源编码
// @param schemeId 方案编码
// @param cityId 城市编码
// @param startDepartureDate 开始日期
// @param endDepartureDate 结束日期
export function getCalendarPrice({
  productId,
  resourceId,
  schemeId = null,
  cityId,
  startDepartureDate,
  endDepartureDate,
  entranceSource,
  memberId,
  channelCode,
}) {
  return post('/product/price/calendar', {
    productId,
    resourceId,
    schemeId,
    cityId,
    startDepartureDate,
    endDepartureDate,
    channelCode: channelCode || sessionStorage.getItem('sourceFlag'),
    terminalCode: sessionStorage.getItem('terminalCode'),
    entranceSource,
    memberId,
  }).then(res => {
    if (res?.departureDateList) {
      let datePrice = {}
      res?.departureDateList.forEach(data => {
        datePrice[data.departureDate] = data
      })
      return datePrice
    } else {
      return res.allDepartureDateList
    }
  })
}

// 根据条件查询资源价格日历
export function getResourcePriceCalendar(
  params = {
    productId: null,
    resourceId: null,
    schemeId: null,
    startDepartureDate: null,
    endDepartureDate: null,
  }
) {
  return post('/product/resource-price/calendar', {
    ...params,
    terminalCode: sessionStorage.getItem('terminalCode'),
  }).then(res => {
    let datePrice = {}
    res?.forEach(data => {
      datePrice[data.departureDate] = data
    })
    return datePrice
  })
}

const getYear = year => {
  return get(
    `/holiday/year/${year}`,
    {},
    {
      codeField: 'code',
      codeNum: 0,
      dataField: 'holiday',
      needEncrypt: false,
    }
  )
}

// 获取日历节假日
export function getCalendarHoliday() {
  const current = moment()
  let request = [getYear(current.year()), getYear(current.year() + 1)] // 目前价格日历横跨12个月（正常实际是13个月），这里需要获取两年的节假日
  return Promise.all(request).then(res => {
    let dateRemarks = {}
    res.forEach(r => {
      Object.values(r).forEach(v => {
        dateRemarks[v.date] = v
      })
    })
    return dateRemarks
  })
}

// 获取城市列表
export function getCityList(params = []) {
  return post('/city', { cityIdList: params.map(p => p.cityId) })
}
// 根据产品号查出发城市
export function getCitylist(params) {
  return post('/product/pro-dep-city', params)
}
// 提交订单
export function bookingOrder(params) {
  const data = {
    ...params,
    creatorType: 1, // 下单人类型，1、C端客户；2、门市销售；3、电话销售；4、内部非销售岗员工；5、社群店主
    channel: params.channel || sessionStorage.getItem('sourceFlag') || '',
  }
  const promoCode = sessionStorage.getItem('promoCode') //推广码
  if (!data.creatorPromotionCode && promoCode) {
    data.creatorPromotionCode = promoCode
  }
  return post('/order/booking', data)
}
export function getCurrentPrice(params) {
  return post('/product/current-price', params)
}
// 活动列表接口
export function getProActivityList(params) {
  return post('/product/pro-coupon-list', {
    ...params,
    activityChannelNoStr: sessionStorage.getItem('sourceFlag'),
    terminalCode: sessionStorage.getItem('terminalCode'),
  })
}
// pro-coupon-list
// 根据出发城市和终端查询爆款商品数据
export function getHotProduct(params) {
  return post('/hot-recommend-product/list', {
    ...params,
    activityChannelNoStr: sessionStorage.getItem('sourceFlag'),
    priceChannelNoStr: sessionStorage.getItem('sourceFlag'),
  })
}
// 参加促销活动 返回折扣金额

export function getCouponPrice(params) {
  return post('/product/join-promotion', {
    ...params,
    activityChannelNoStr: sessionStorage.getItem('sourceFlag'),
    terminalCode: sessionStorage.getItem('terminalCode'),
  })
}
// 产品一级品类查询
export function getFirstClass(params) {
  return post('/product/first-class', params)
}
// 查询所有标签枚举
export function getAllTags(params) {
  return post('/product/all-tags', params)
}
// 上报分享进来的店主id
export function reportShopkeeperId(params) {
  return post('/product/add-member-shopkeeper', params)
}
// 获取证件类型
export function getCertTypeList(params) {
  return post('/order/enum/values', params)
}
// 获取场次
export function getSeasonList(params) {
  return post('/product/resource/individual-resource/query', params)
}
// 根据资源ID获取出游信息配置
// export function getTouristList(params) {
//   return post('/product/tourist-limit-config/get-biz-key', params)
// }
// 根据资源ID获取出游信息配置/支持多个资源ID查询
export function getTouristList(params) {
  return post('/product/tourist-limit-config/get-biz-key/v2', params)
}

//中石油优惠劵
export function getCouponList(params) {
  return post('/product/get-coupon-list', params)
}
//获取验证码
export function getMobileCode(params) {
  return post('/send/mobile-code', params)
}
//查询会员注册信息(含注册)
export function getMemberRegisterInfo(params) {
  return post('/get-member-register-info', params)
}
//确认领取接口
export function getCouponInfo(params) {
  return post('/product/member-one-click-get-coupon', {
    ...params,
    terminalCode: sessionStorage.getItem('terminalCode'),
  })
}
//酒店详情
export function getHotelInfo(params) {
  return post('/product/hotel/detail', { ...params, invoiceType: 'ctg', payType: 'pp' })
}
//酒店房型列表
export function getHotelRoomInfo(params) {
  return post('/product/get-hotel-room-info', {
    ...params,
    terminalCode: sessionStorage.getItem('terminalCode'),
  })
}
//酒店具体售卖房型信息
export function getHotelRoomInfoDetail(params) {
  return post('/product/get-hotel-room-info/detail', {
    ...params,
    invoiceType: 'ctg',
    payType: 'pp',
    terminalCode: sessionStorage.getItem('terminalCode'),
  })
}
// 酒店列表
export function queryHotelProductList(params) {
  return post('/product/hotels', {
    ...params,
    terminalCode: sessionStorage.getItem('terminalCode'),
  })
}

// 根据资源基础信息表id集合查询资源结构化详细信息
export function getResourceDetail(params) {
  return post('/product/resource-structural/list', params)
}

// 签证&认证产品适用人群邮件发送
export function visaSendEmail(params) {
  return post('/product/visa-send-email', params)
}

// 签证&认证-计算产品的资源价格
export function resourceCalculate(params) {
  return post('/product/resource-calculate', params)
}

// 产品基本信息查询
export function productBasic(params) {
  return post('/product/product-basic', params)
}
// 获取境外所有城市分组数据
export function cityRegionMap(params) {
  return post('/city-region-map', params)
}
// 根据行程编号查询行程详情
export function getJourney(params) {
  return post('/product/journey/detail', params)
}
// 签约合同信息查询
export function getContract(params) {
  return post('/product/sign/contract', {
    ...params,
    terminalCode: sessionStorage.getItem('terminalCode'),
  })
}
// 根据产品编码查询促销详情
export function getPromotion(params) {
  return post('/product/promotion/detail', {
    ...params,
    activityChannelNoStr: sessionStorage.getItem('sourceFlag'),
    terminalCode: sessionStorage.getItem('terminalCode'),
  })
}
// 根据资源id查询资源价格详情(签证-认证)
export function getResourceInfoList(params) {
  return post('/product/resource-info/details', {
    ...params,
    terminalCode: sessionStorage.getItem('terminalCode'),
  })
}
// 根据产品编码查询促销详情
export function getGradeInfo(params) {
  return post('/product/grade-info', {
    ...params,
  })
}
// 列表
export function getTicketlist() {
  return get('/data-config/scenic-list', {}, { needEncrypt: false })
}
export function getTicketDetail(params) {
  return get('/data-config/scenic-detail', params, { needEncrypt: false })
}
// 加入店铺
export function joinShop(params) {
  return post(
    `/shop/join-shop`,
    {
      ...params,
    },
    {
      prefix: '/community-server/openapi',
    }
  )
}

// 查询kLook产品的销售属性
export function kLookSalesAttribute(params) {
  return post(`/product/kLook/sales-attribute`, {
    ...params,
    channel: sessionStorage.getItem('sourceFlag'),
  })
}

// 根据所选的销售属性查询kLook套餐资源
export function kLookResourceList(params) {
  return post(`/product/kLook/resource-list`, {
    ...params,
    channel: sessionStorage.getItem('sourceFlag'),
  })
}

// 积分抵扣接口
export function productDeduct(params) {
  return post('/discounts/product/deduct', {
    ...params,
    terminalCode: sessionStorage.getItem('terminalCode'),
    error: false,
  })
}

// 可享积分接口
export function productProduce(params) {
  return post('/discounts/product/produce', {
    ...params,
    terminalCode: sessionStorage.getItem('terminalCode'),
  })
}

// 景点详情
export function queryPoiDetail(params) {
  return post('/poi/product/poi/detail', params)
}

// 省级目的地
export function queryProvinceDetail(params) {
  return post('/poi/product/info/province', params)
}

// 市级目的地
export function queryCityDetail(params) {
  return post('/poi/product/info/city', params)
}

// 市级目的地
export function getKlookResourceList(params) {
  return post('/product/kLook/resource-list', {
    ...params,
    channel: sessionStorage.getItem('sourceFlag'),
  })
}

// 判断产品品类
export function productExists(params) {
  return post('/product/exists', params)
}

// 判断产品品类
export function queryFlashSaleInfo(params) {
  return post('/seckill/product/current-rounds', params)
}

// 产品详情-相关推荐
export function aboutRecommend(params, other = {}) {
  return axios(
    {
      url: `/openapi/product/getRelatedProducts`,
      baseURL: config.domainName,
      method: 'get',
      params: params,
      headers: {
        'Content-Type': 'application/json',
        loginToken: sessionStorage.getItem('loginToken'),
      }, // 头部信息处理
      transformResponse: [
        function (response) {
          return JSON.parse(response.replace(/("id":)(\d{0,})(,)/g, '$1' + '"' + '$2' + '"' + '$3'))
        },
      ],
    },
    {
      prefix: config.mobServer,
      ...other,
    }
  ).then(res => {
    // 直接返回 records 数组
    return res?.data?.data?.records || []
  })
}

// 收藏/取消收藏
export function interactAction(params) {
  return post('/interact/action', {
    ...params,
    error: '操作失败请稍后重试',
  })
}

// 保存用户浏览记录
export function saveUserBrowseRecords(params) {
  return post('/interact/saveUserBrowseRecords', {
    memberId: sessionStorage.getItem('memberId') || '',
    ...params,
    error: '操作失败请稍后重试',
  })
}
